/**
 * AI 답변의 텍스트 포맷팅을 처리하는 유틸리티 함수
 */
export const formatAiAnswer = (rawAnswer) => {
    if (!rawAnswer) return "";
    let formatted = rawAnswer;

    // 1. 영어 라벨을 한국어로 변경
    formatted = formatted.replace(/1\)\s*Answer/gi, "1) 답변");
    formatted = formatted.replace(/2\)\s*Relevant Articles/gi, "2) 관련 조항");

    // 2. "3) Notes" 또는 "3) 참고" 이후 내용 제거
    if (formatted.match(/3\)\s*(Notes|참고)/i)) {
        formatted = formatted.split(/3\)\s*(?:Notes|참고)/i)[0].trim();
    }

    // 3. [MEMORY_UPDATE_CAPTURED] 부분과 그 이후 내용 전체 삭제
    formatted = formatted.split('[MEMORY_UPDATE_CAPTURED]')[0].trim();

    // 4. 마크다운 볼드(**)를 HTML <strong> 태그로 변환
    let isBold = false;
    formatted = formatted.replace(/\*\*/g, () => {
        isBold = !isBold;
        return isBold ? '<strong>' : '</strong>';
    });

    // 5. 별표를 HTML의 <em>(기울임) 태그로 변환
    formatted = formatted.replace(/\*\((.*?)\)\*/g, "<em>($1)</em>");

    // 6. 줄바꿈을 <br /> 태그로 변환
    formatted = formatted.replace(/\n/g, '<br />');

    return formatted;
};

/**
 * 법령 근거(Citations) 데이터의 중복을 제거하고 텍스트를 클리닝하는 유틸리티 함수
 */
export const processCitations = (rawCitations) => {
    if (!rawCitations || rawCitations.length === 0) return [];

    const uniqueMap = new Map();

    rawCitations.forEach(cite => {
        let cleanSnippet = cite.snippet || "";

        cleanSnippet = cleanSnippet.replace(/^\d+\s+조문.*?[A-Z]\s+(제\d+조(?:주의|의\d+)?(?:\([^)]+\))?)/, '$1');
        cleanSnippet = cleanSnippet.replace(/(^|\s)(\d+\.)\s*\2\s*/g, '$1$2 ');
        cleanSnippet = cleanSnippet.replace(/(^|\s)([가-힣A-Za-z]+\.)\s*\2\s*/g, '$1$2 ');
        cleanSnippet = cleanSnippet.replace(/(^|\s)([①-⑳])\s*\2\s*/g, '$1$2 ');
        cleanSnippet = cleanSnippet.replace(/(^|\s)(\d+)\.\s+(?=[^\d\s])/g, '$1$2호 ');
        cleanSnippet = cleanSnippet.trim();

        const quotesCount = (cleanSnippet.match(/"/g) || []).length;
        if (quotesCount % 2 !== 0) {
            cleanSnippet = cleanSnippet.replace(/\s*"[^"]*$/, '');
        }
        cleanSnippet = cleanSnippet.replace(/(?:\s+\d+호|\s+[가-힣]\.)\s*[^.\n]{0,8}$/, '');

        let cleanSource = cite.source || "";
        cleanSource = cleanSource.replace(/\/(\d+)\.?$/, '/$1호').replace(/(?<!\/)(\d+)\.$/, '$1호');

        uniqueMap.set(cleanSnippet, {
            ...cite,
            source: cleanSource,
            snippet: cleanSnippet
        });
    });

    return Array.from(uniqueMap.values());
};
